export const productDetailsData =[
    {
        id: 1,
        img: "ecommerce/01.jpg",
        name: "Women's Top",
        note: "Regular Flare Fit Women's white Top",
        description: "Rock Paper Scissors Various Dots Half Sleeves Girl’s Regular Fit T-Shirt I 100% Cotton T Shirt with Half Sleeve Round Neck.",
        discountPrice: "350.00",
        status: "none",
        price: 100.00,
        stock: "In stock",
        review: "(200 review)",
        category: "Women's Top",
        colors: [
            "White",
            "gray"
        ],
        size: [
            "M",
            "L",
            "XL"
        ],
        tags: [
            "Diesel",
            "Hudson",
            "Lee"
        ],
        variants: [
            {
                color: "White",
                images: "ecommerce/01.jpg"
            },
            {
                color: "gray",
                images: "ecommerce/04.jpg"
            },
            {
                color: "black",
                images: "ecommerce/02.jpg"
            },
            {
                color: "pink",
                images: "ecommerce/03.jpg"
            }
        ]
    },
    {
        id: 2,
        "img": "ecommerce/02.jpg",
        "name": "Jeans Jacket",
        "note": "Blue Denim Regular Men's Denim Jacket",
        "discription": "Lorate Solid Men's Fashion Full Sleeves Latest Jacket for Men With Button Closure Long Sleeve Casual Torn Lycra Denim Jacket.",
        "discountPrice": "480.00",
        "status": "sale",
        "color":"ribbon-danger",
        "price": 120.00,
        "stock": "In stock",
        "review": "(120 review)",
        "category": "Jeans Jacket",
        "colors": [
            "green",
            "gray"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Levis",
            "Hudson",
            "Lee"
        ],
        "variants": [
            {
                "color": "White",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
        id: 3,
        
        "img": "ecommerce/03.jpg",
        "name": "Woman's T-Shirt",
        "note": "Cotton Regular Fit Women's T-shirt",
        "discription": "Ravaiyaa - Attitude is everything Cotton Women's Dresses One Top Button T-Shirt.",
        "discountPrice": "350.00",
        "price": "340.00",
        "status": "none",
        "stock": "In stock",
        "review": "(100 review)",
        "category": "Woman's T-Shirt",
        "colors": [
            "White",
            "gray",
            "blue"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Diesel",
            "Spykar",
            "Lee"
        ],
        "variants": [
            {
                "color": "White",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
        id: 4,
        
        "img": "ecommerce/04.jpg",
        "name": "Denim Jacket",
        "note": "Men's Regular Blue Denim Jacket.",
        "discription": "Full Sleeves Latest Jacket for Men With Button Closure Long Sleeve Casual Torn Lycra Denim Jacket.",
        "discountPrice": "350.00",
        "price": "526.00",
        "status": "50%",
        "color":"ribbon-success",
        "stock": "In stock",
        "review": "(80 review)",
        "category": "Denim Jacket",
        "colors": [
            "red",
            "gray",
            "blue"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Levis",
            "Lee",
            "Hudson"
        ],
        "variants": [
            {
                "color": "White",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
    id: 5,
    
        "img": "ecommerce/03.jpg",
        "name": "Woman's T-Shirt",
        "note": "Cotton Regular Fit Women's T-shirt",
        "discription": "Ravaiyaa - Attitude is everything Cotton Women's Dresses One Top Button T-Shirt.",
        "discountPrice": "350.00",
        "price": 1000.00,
        "status": "sale",
        "color":"ribbon-danger",
        "stock": "In stock",
        "review": "(250 review)",
        "category": "Woman's T-Shirt",
        "colors": [
            "orange",
            "pink",
            "blue"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Lee"
        ],
        "variants": [
            {
                "color": "White",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
    id: 6,
    
        "img": "ecommerce/02.jpg",
        "name": "Jeans Jacket",
        "note": "Blue Denim Regular Men's Denim Jacket",
        "discription": "Lora's Solid Men's Fashion Full Sleeves Latest Jacket for Men With Button Closure Long Sleeve Casual Torn Lycra Denim Jacket.",
        "discountPrice": "480.00",
        "price": 926.00,
        "status": "none",
        "stock": "In stock",
        "review": "(100 review)",
        "category": "Jeans Jacket",
        "colors": [
            "purple",
            "orange",
            "blue"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Lee",
            "Lifestyle",
            "Nike"
        ],
        "variants": [
            {
                "color": "White",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
    id: 7,
    
        "img": "ecommerce/06.jpg",
        "name": "Black One Piece",
        "note": "Polyester Blend Women's Fit Dress",
        "discription": "Ravaiyaa - Attitude is everything Cotton Women's Dresses One Piece Button Dress.",
        "discountPrice": "780.00",
        "price": 200.00,
        "status": "none",
        "stock": "In stock",
        "review": "(100 review)",
        "category": "Black One Piece",
        "colors": [
            "purple",
            "pink",
            "blue"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Hudson",
            "Lee"
        ],
        "variants": [
            {
                "color": "White",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
    id: 8,
    
        "img": "ecommerce/01.jpg",
        "name": "Women's Top",
        "note": "Regular Flare Fit Women's white Top",
        "discription": "Rock Paper Scissors Various Dots Half Sleeves Girl’s Regular Fit T-Shirt I 100% Cotton T Shirt with Half Sleeve Round Neck.",
        "discountPrice": "320.00",
        "price": 206.00,
        "stock": "In stock",
        "status": "none",
        "review": "(250 review)",
        "category": "Women's Top",
        "colors": [
            "green",
            "gray",
            "blue"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Denien",
            "Diesel",
            "Spykar"
        ],
        "variants": [
            {
                "color": "White",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
    id: 9,
    
        "img": "ecommerce/01.jpg",
        "name": "Women's Top",
        "note": "Regular Flare Fit Women's white Top",
        "discription": "Rock Paper Scissors Various Dots Half Sleeves Girl’s Regular Fit T-Shirt I 100% Cotton T Shirt with Half Sleeve Round Neck.",
        "discountPrice": "900.00",
        "price": 726.00,
        "status": "none",
        "stock": "In stock",
        "review": "(250 review)",
        "category": "Women's Top",
        "colors": [
            "White",
            "pink",
            "blue"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Spykar"
        ],
        "variants": [
            {
                "color": "purple",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "pink",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "blue",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "white",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
    id: 10,
    
        "img": "ecommerce/05.jpg",
        "name": "Black, White Dress.",
        "note": "White Cotton Regular Fabric Fit Dress",
        "discription": "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
        "discountPrice": "450.00",
        "price": 200.00,
        "status": "none",
        "stock": "In stock",
        "review": "(250 review)",
        "category": "Black, White dress",
        "colors": [
            "purple",
            "pink",
            "blue"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Hudson",
            "Lee"
        ],
        "variants": [
            {
                "color": "White",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
    id: 11,
    
        "img": "ecommerce/02.jpg",
        "name": "Jeans Jacket",
        "note": "Blue Denim Regular Men's Denim Jacket",
        "discription": "Lorate Solid Men's Fashion Full Sleeves Latest Jacket for Men With Button Closure Long Sleeve Casual Torn Lycra Denim Jacket.",
        "discountPrice": "450.00",
        "price": 426.00,
        "status": "none",
        "stock": "In stock",
        "review": "(250 review)",
        "category": "Jeans Jacket",
        "colors": [
            "White",
            "pink",
            "blue"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Diesel",
            "Hudson",
            "Lee"
        ],
        "variants": [
            {
                "color": "White",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "pink",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "blue",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "gray",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
    id: 12,
    
        "img": "ecommerce/03.jpg",
        "name": "Woman's T-Shirt",
        "note": "Cotton Regular Fit Women's T-shirt",
        "discription": "Ravaiyaa - Attitude is everything Cotton Women's Dresses One Top Button T-Shirt.",
        "discountPrice": "850.00",
        "price": 626.00,
        "status": "none",
        "stock": "In stock",
        "review": "(250 review)",
        "category": "Woman's T-Shirt",
        "colors": [
            "White",
            "pink",
            "blue"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Diesel",
            "Hudson",
            "Lee"
        ],
        "variants": [
            {
                "color": "White",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "pink",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "blue",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "purple",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
    id: 13,
    
        "img": "ecommerce/05.jpg",
        "name": "Black, White Dress.",
        "note": "White Cotton Regular Fabric Fit Dress",
        "discription": "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
        "discountPrice": "560.00",
        "price": 450.00,
        "status": "none",
        "stock": "In stock",
        "review": "(250 review)",
        "category": "Black, White dress",
        "colors": [
            "White",
            "pink",
            "blue"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Diesel",
            "Hudson",
            "Lee"
        ],
        "variants": [
            {
                "color": "White",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "pink",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "blue",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "black",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
    id: 14,
    
        "img": "ecommerce/01.jpg",
        "name": "Women's Top",
        "note": "Regular Flare Fit Women's white Top",
        "discription": "Rock Paper Scissors Womens Tank Top High Neck Cotton Top Stylish Women Top..",
        "discountPrice": "650.00",
        "price": 26.00,
        "status": "none",
        "stock": "In stock",
        "review": "(250 review)",
        "category": "Women's Top",
        "colors": [
            "White",
            "blue",
            "yellow"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Diesel",
            "Lee"
        ],
        "variants": [
            {
                "color": "White",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "blue",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "yellow",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "pink",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
    id: 15,
    
        "img": "ecommerce/02.jpg",
        "name": "Jeans Jacket",
        "note": "Blue Denim Regular Men's Denim Jacket",
        "discription": "Lora's Solid Men's Fashion Full Sleeves Latest Jacket for Men With Button Closure Long Sleeve Casual Torn Lycra Denim Jacket.",
        "discountPrice": "520.00",
        "price": 26.00,
        "status": "Hot",
        "color":"ribbon-clip ribbon-warning",
        "stock": "In stock",
        "review": "(250 review)",
        "category": "Jeans Jacket",
        "colors": [
            "black",
            "blue",
            "yellow"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Lee"
        ],
        "variants": [
            {
                "color": "black",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "blue",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "yellow",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "yellow",
                "images": "ecommerce/03.jpg"
            }
        ]
    },
    {
    id: 16,
    
        "img": "ecommerce/03.jpg",
        "name": "Woman's T-Shirt",
        "note": "Cotton Regular Fit Women's T-shirt",
        "discription": "Ravaiyaa - Attitude is everything Cotton Women's Dresses One Top Button T-Shirt.",
        "discountPrice": "420.00",
        "price": 150.00,
        "status": "none",
        "stock": "Out of stock",
        "review": "(250 review)",
        "category": "Woman's T-Shirt",
        "colors": [
            "black",
            "pink",
            "yellow"
        ],
        "size": [
            "M",
            "L",
            "XL"
        ],
        "tags": [
            "Hudson"
        ],
        "variants": [
            {
                "color": "black",
                "images": "ecommerce/01.jpg"
            },
            {
                "color": "pink",
                "images": "ecommerce/04.jpg"
            },
            {
                "color": "yellow",
                "images": "ecommerce/02.jpg"
            },
            {
                "color": "blue",
                "images": "ecommerce/02.jpg"
            }
        ]
    }
]